import { render } from "./DanWeiDetail.vue?vue&type=template&id=0ec25e06&scoped=true"
import script from "./DanWeiDetail.vue?vue&type=script&lang=js"
export * from "./DanWeiDetail.vue?vue&type=script&lang=js"

import "./DanWeiDetail.vue?vue&type=style&index=0&id=0ec25e06&scoped=true&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec25e06"]])

export default __exports__